module.exports = __webpack_public_path__ + "img/max-ulichney-scuba.8b56e60.jpg";